import React from "react";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";

// Mirrors the real row height and the default page size, so the table does not jump when the data
// arrives and the wait does not read as a broken screen.

const PLACEHOLDER_ROWS = 10;

export default function LcvManualPrizeWinsGridSkeleton() {
     return (
          <Box>
               {Array.from({ length: PLACEHOLDER_ROWS }).map((unused, index) => (
                    <Box
                         key={index}
                         sx={{
                              display: "flex",
                              gap: 2,
                              py: 1.5,
                              borderBottom: "1px solid",
                              borderColor: "divider",
                         }}
                    >
                         <Skeleton variant="text" width="16%" />
                         <Skeleton variant="text" width="20%" />
                         <Skeleton variant="text" width="16%" />
                         <Skeleton variant="text" width="14%" />
                         <Skeleton variant="text" width="8%" />
                         <Skeleton variant="text" width="10%" />
                         <Skeleton variant="text" width="12%" />
                    </Box>
               ))}
          </Box>
     );
}
